import { getTrolleyLinkApiV1 } from "@/api/__generated__/api.schema";
import { useWorkspaceId } from "@/hooks/auth/use-workspace";
import { useResetPayoutQuery } from "@/routes/payout/hooks/use-reset-payout-query";
import { openWindowPopup } from "@/utils/window";
import { useCallback } from "react";

export const useOpenTrolley = () => {
  const workspaceId = useWorkspaceId();
  const resetPayoutQuery = useResetPayoutQuery();
  return useCallback(async () => {
    const { data } = await getTrolleyLinkApiV1(workspaceId);
    openWindowPopup(data?.url, {
      width: window.screen.width,
      height: 960,
      centerScreen: false,
      onClose: () => {
        resetPayoutQuery();
      },
    });
  }, [workspaceId, resetPayoutQuery]);
};
